import React, { useContext } from 'react';
import classNames from './HomePageView.module.css';
import { observer } from 'mobx-react-lite';
import { GlobalContext } from '../components/ExtensionWindow/GlobalContext';
import { ProductName } from "../Styles/ProductName";
import ChronologicalReport from "../images/ChronologicalSearchReport.png";
import DataExfiltrationReport from "../images/DataExfiltrationReport.png";
import DataRecipientsReport from "../images/DataRecipientsReport.png";
import pinExtensionImage from "../images/pin-extension.png";
import pinnedExtensionImage from "../images/pinned.png";
import { ProfessionalEditionFeatureList } from './LicensePageView';
import { ExtensionInstructionsView } from './ExtensionInstructionsView';
import { AddressBarMenuIcon } from '../react-constants';

const ExpandableFigure = ({children, ...props}: React.ComponentProps<'figure'>) => (
	<div className={classNames.ExpandableFigureContainer}>
		<figure className='static' {...props}>{children}</figure>
		<figure className='inflate' {...props}>{children}</figure>
	</div>
)


export const HomePageView = observer( () => {
	const globalContext = useContext(GlobalContext);
	if (globalContext == null) return null;
	// const {licenseCache} = globalContext;
	// const isLicensed = licenseCache.validNonExpiredLicenses.length > 0;
	return (		
		<div className={classNames.SingleColumnPageContainerElement}><div className={classNames.SingleColumnLeftJustifiedWidthLimited}>
			<h2>Used Why?! Your Software Does What?!</h2>
			<p>
				<ProductName/> is a Chrome extension for conducting privacy investigations of websites as you use them. It searches websites' communications (network traffic) for information websites share with third parties that track and profile you online: information such as your location, your IP address, and text you enter into forms.
			</p>
			<p>
			</p>
			<div className={classNames.MultiFigure}>
				<ExpandableFigure>
					<img
						src={ChronologicalReport}
						alt={`A screenshot showing a list of events in which an IP address, zip code, and city (Cambridge) are sent to third-parties`}
						/>
					<figcaption>Search network traffic in real time</figcaption>
				</ExpandableFigure>
				<ExpandableFigure>
					<img src={DataExfiltrationReport}
						alt={`A screenshot showing the data sent to third-parties`}
					/>
					<figcaption>Examine data exfiltrations by data type</figcaption>
				</ExpandableFigure>
					<ExpandableFigure>
					<img src={DataRecipientsReport}
						alt={`A screenshot showing the third parties receiving the user's IP address, zip code, and city (Cambridge).`}
					/>
					<figcaption>Examine data exfiltrations by destination</figcaption>
				</ExpandableFigure>
			</div>
			<p>
				The extension appears within your Chrome's developers tools (or the tools of other Chromium based browsers, such as Microsoft's Edge). You can also use the extension to record video of your investigations.
			</p>
			<h2>Built by Whom?!</h2>
			<p>
				<a href="https://stuartschechter.org/">Stuart Schechter</a>: a scientist who has spent decades doing consumer-focused research in security, privacy, and ethics.
			</p>
			<h2>Priced How?!</h2>
				<p>
					<b>The Free Personal Edition, for non-commercial use only</b> (explained in more detail in the <a href="#Licensing">Licensing</a> section below), empowers you to examine what information websites share and with whom they share it, so you can witness just how promiscuous this sharing can be.
				</p>
				<p><b>The Professional Edition</b> provided with a commercial license includes features essential to professional investigations:
				</p>
				<ProfessionalEditionFeatureList/>

			<h2>Installed How?! Into my Browser?!</h2>
				<p>Install from the a <a href="https://chromewebstore.google.com/detail/mydatagowhere/jklinjlnhaapokkmcbldhkddmfknabfh">Chrome Store</a>.</p>

				<p>Then Pin the extension to the address bar by:</p>
				<ol>
					<li>Clicking on the extensions (puzzle piece) icon to the right of the address bar</li>
					<li>Clicking the icon in the shape of a pin to the right of "MyDataGoesWhere?!".</li>
				</ol>


				<div className={classNames.MultiFigure}>
					<ExpandableFigure>
						<img src={pinExtensionImage} alt="an image of an Extensions menu, with a menu item named MyDataGoesWhere?!, and the icon of a PIN used to pin the extension to the address bar." />
					<figcaption>Pinning the extension to the address bar</figcaption>
					</ExpandableFigure>
						<ExpandableFigure>
							<img src={pinnedExtensionImage} alt="an image of a section of the browser window to the right of the address bar, with this Extension's icon (an arrow pointing both left and right) just to the right of the address bar and just to the left of the extension icon in the shape of a puzzle piece." />
							<figcaption>The icon (left right arrow) is pinned to the address bar.</figcaption>
					</ExpandableFigure>
				</div>

				<p>The <ProductName/> icon, an arrow pointing left and right (<AddressBarMenuIcon/>), representing bidirectional data flow, should now appear next to the extensions (puzzle piece) icon in the address bar.</p>

				<h2>Used How?!</h2>
					<ExtensionInstructionsView/>

			<h2 id="Licensing">Licensing — the Don't Undermine the Authors Livelihood (DUAL) License</h2>

				<p>Stuart created this product with his own time and money for privacy investigations he is frequently hired to conduct.</p>

				<p>This software is provided strictly for non-commercial, individual, personal use to educate and inform the user about the behaviors of the websites they use.</p>

				<p>Commercial use is prohibited, and commercial use includes, but is not limited, to:</p>
				<ol>
					<li>any work-for-hire in which one uses this software;</li>
					<li>the submission of any results, reports, or screenshots as part of work for hire or professional/commercial services;</li>
					<li>the collection or submission of any results, reports, or screenshots in a trial, arbitration, or dispute, including (but not limited to) submission to a court of law or threat of legal action;</li>
					<li>the use of this software to make decisions or recommendations as part of work for hire or professional/commercial services;</li>
					<li>the publishing of data, findings, or other results generated by this software, especially if used to circumvent the restrictions herein;</li> 
					<li>the creation of derivative works.</li>
				</ol>
			<p>If you would like to use this product for anything other than personal non-commercial, or if there are software components herein that you would like to use in other products, please obtain a separate license from <a href="mailto: my-data-go-where@stuartschechter.org">Stuart (the author)</a>.</p>

			<p>If you would like to use this product for journalism, <a href="mailto: my-data-go-where@stuartschechter.org">Stuart (the author)</a> encourages you to reach out for a free Journalist's license. The author requires journalists to obtain a license to distinguish true investigative journalism from predatory use under the legal cover of journalism.</p>

			<footer>
				Copyright&nbsp;{ (new Date()).getFullYear() }&nbsp;<a href="https://stuartschechter.org">Stuart Schechter</a>&nbsp;&nbsp;&nbsp;&nbsp;<a href="/privacy">Privacy Policy</a>
			</footer>
		</div></div>
	);
});

